"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferNotActive = OfferNotActive;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const index_1 = require("@src/app/index");
const button_1 = __importDefault(require("components/modules/global/button"));
function OfferNotActive() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "panel panel--payment u-text-center", children: [(0, jsx_runtime_1.jsx)("h4", { className: "offer-detail__cta-not-active__text", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.this_offer_is_not_available", defaultMessage: "Bohu\u017Eia\u013E, t\u00E1to ponuka u\u017E nie je dostupn\u00E1." }) }), (0, jsx_runtime_1.jsx)(button_1.default, { text: intl.formatMessage({
                    id: 'offer_detail.details.go_to_offers',
                    defaultMessage: 'Prejsť na ponuky',
                }), 
                // @ts-ignore
                onClick: () => index_1.history.pushLocalized('/ponuky') })] }));
}
